import { useState } from 'react';

import Checkbox from '@components/Checkbox';
import palette from '@utils/theme/palette';
import {
  Description,
  ListingItemsWrapper,
  Title,
} from '@components/views/tour/components/next/Segments/styled';
import Tooltip from '@components/ui/Tooltip/next';

import { ListingFilterItemInterface } from './type';
import {
  MultiSelectionItemWrapper,
  SubTitle,
  CheckboxLabel,
  CheckboxName,
  CheckboxContainer,
  ShortName,
} from './styled';

const SelectionItemDesktop = ({
  item,
  subTitleKey,
  value,
  onChange,
  colorSegment,
  shortDesc,
  tooltip,
}: {
  singleItemClassName?: string;
  item: ListingFilterItemInterface;
  subTitleKey: string;
  value?: boolean;
  onChange: (selected: boolean) => void;
  colorSegment?: string;
  shortDesc?: boolean;
  description?: string;
  tooltip?: string;
}) => {
  const itemSubTitle = subTitleKey
    ? item?.[subTitleKey as keyof ListingFilterItemInterface]
    : null;
  const [visible, setVisible] = useState(false);

  return (
    <Tooltip
      getPopupContainer={(triggerNode) => triggerNode}
      trigger='hover'
      borderRadius='8px'
      overlayInnerStyle={{
        maxHeight: '190px',
        overflow: 'auto',
        borderRadius: '8px',
        border: 'none',
        backgroundColor: palette.white,
        width: '220px',
      }}
      placement='bottomRight'
      arrowColor={palette.white}
      open={visible}
      title={
        <ListingItemsWrapper>
          <Title badgeColor={colorSegment}>{item.value}</Title>
          <Description>{tooltip}</Description>
        </ListingItemsWrapper>
      }
    >
      <MultiSelectionItemWrapper
        onMouseEnter={() => setVisible(true)}
        onMouseLeave={() => setVisible(false)}
        colorSegment={colorSegment}
      >
        <Checkbox
          testid='checkbox'
          onChange={onChange}
          checked={value}
          value={value}
          mode='controlled'
          segment={true}
        >
          <CheckboxLabel>
            <CheckboxContainer>
              <CheckboxName>
                {item.value}
                {itemSubTitle ? (
                  <SubTitle>{'(' + itemSubTitle + ')'}</SubTitle>
                ) : null}
              </CheckboxName>
              <ShortName>{shortDesc}</ShortName>
            </CheckboxContainer>
          </CheckboxLabel>
        </Checkbox>
      </MultiSelectionItemWrapper>
    </Tooltip>
  );
};

export default SelectionItemDesktop;
